<div class="layout-centered">
  <h1 class="error-code">{{ errorCode }}</h1>

  <h2 class="error-subtitle">Oops! Das hätte nicht passieren dürfen...</h2>
  <h3 class="error-message">{{ errorMessage }}</h3>
</div>
